import React from 'react';

// WhatsApp-style delete chat popup
export default function DeleteChatModal({ onDeleteForMe, onClose }) {
  return (
    <>
      {/* Backdrop */}
      <div className="fixed inset-0 z-50 bg-black/50" onClick={onClose} />

      {/* Bottom sheet */}
      <div className="fixed bottom-0 left-0 right-0 z-50 bg-white rounded-t-3xl shadow-2xl pb-safe">
        <div className="px-5 pt-4 pb-6">
          {/* Handle */}
          <div className="w-10 h-1 bg-gray-200 rounded-full mx-auto mb-5" />

          <h3 className="text-base font-bold text-text-primary font-heading mb-1">Delete Chat?</h3>
          <p className="text-xs text-text-muted mb-5">This action cannot be undone</p>

          <div className="space-y-2">
            {/* Delete for me */}
            <button onClick={onDeleteForMe}
              className="w-full flex items-center gap-4 px-4 py-4 rounded-2xl bg-surface hover:bg-slate-100 active:bg-slate-100 transition-colors text-left">
              <div className="w-10 h-10 bg-blue-100 rounded-full flex items-center justify-center flex-shrink-0">
                <i className="fa-solid fa-user text-blue-600 text-base" />
              </div>
              <div>
                <p className="text-sm font-semibold text-text-primary">Delete for me</p>
                <p className="text-xs text-text-muted mt-0.5">This chat will be removed only from your list</p>
              </div>
            </button>


            {/* Cancel */}
            <button onClick={onClose}
              className="w-full py-3.5 rounded-2xl border border-border text-sm font-semibold text-text-secondary">
              Cancel
            </button>
          </div>
        </div>
      </div>
    </>
  );
}
